import { Collapse } from '@mui/material'
import clsx from 'clsx'
import { SetUpPasswordForm, SyncAuthyForm } from 'components/core-v2'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import Tick from '../../../assets/tick.svg?react'
import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'
import classes from './confirm-account.module.scss'

const { setUpPassword } = COPY

interface Props {
  setStep: (step: number) => void
  step: number
  username: string
}
const MainElement = ({ setStep, step, username }: Props) => {
  const isStepOne = step === 1
  const [timedStep, setTimedStep] = useState(1)
  const isStepTwo = step === 2

  useEffect(() => {
    let timeoutId = null
    if (step === 2) {
      timeoutId = setTimeout(() => setTimedStep(2), 1500)
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [step])

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.progressTrack, {
          [classes.progressTrackStepOne]: isStepOne,
          [classes.progressTrackStepTwo]: isStepTwo
        })}
      >
        <Tick
          className={clsx(classes.tickOne, {
            [classes.tickOneStepOne]: isStepOne,
            [classes.tickOneStepTwo]: isStepTwo
          })}
        />
        <div
          className={clsx(classes.line, {
            [classes.lineStepTwo]: isStepTwo
          })}
        />
        <Tick
          className={clsx(classes.tickTwo, {
            [classes.tickTwoStepOne]: isStepOne,
            [classes.tickTwoStepTwo]: isStepTwo
          })}
        />
      </div>
      <div className={classes.stepOneWrapper}>
        <Collapse in={isStepOne} timeout={700}>
          <div className={classes.card}>
            <h2>{setUpPassword.stepOneHeading}</h2>
            <SetUpPasswordForm on2FANotSetup={() => setStep(2)} usernameDefaultValue={username} />
          </div>
        </Collapse>
        <h2
          className={clsx(classes.stepOneFauxHeading, {
            [classes.stepOneFauxHeadingActive]: isStepTwo
          })}
        >
          {setUpPassword.stepOneHeading}
        </h2>
      </div>
      <div className={classes.stepTwoWrapper}>
        <Collapse in={timedStep === 2} timeout={700}>
          <div className={classes.card}>
            <h2>{setUpPassword.stepTwoHeading}</h2>
            {timedStep === 2 && <SyncAuthyForm />}
          </div>
        </Collapse>
        <h2
          className={clsx(classes.stepTwoFauxHeading, {
            [classes.stepTwoFauxHeadingInactive]: isStepTwo
          })}
        >
          {setUpPassword.stepTwoHeading}
        </h2>
      </div>
    </div>
  )
}

export const ConfirmAccount = () => {
  const [step, setStep] = useState(1)
  const { username } = useParams()
  return (
    <TwoColumnWithImage
      mainElement={<MainElement setStep={setStep} step={step} username={username} />}
      title={setUpPassword.title}
      width="510px"
    />
  )
}
